import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { combineLatest, take } from 'rxjs';

import { BaseStoreService, CustomLanguageService } from '@seb/web-common/core/services';

@Component({
  selector: 'wc-iadvize-script',
  templateUrl: 'iadvize.script.component.html',
  standalone: true
})
export class IadvizeScriptComponent implements OnInit {
  constructor(
    private readonly baseStoreService: BaseStoreService,
    private readonly languageService: CustomLanguageService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  ngOnInit(): void {
    const baseStore = this.baseStoreService.baseStore;
    if (baseStore?.enableIadvize && baseStore?.iadvizeSID) {
      combineLatest([
        this.languageService.getAll(),
        this.languageService.getActive()
      ]).pipe(
        take(1)
      ).subscribe(([languages, activeLanguage]) => {
        const isBilingual = languages?.length > 1;
        if (isBilingual) {
          this.initializeIadvizeScript(baseStore.iadvizeSID);
        } else {
          this.initializeIadvizeScript(baseStore.iadvizeSID, activeLanguage || '');
        }
      });
    }
  }

  private initializeIadvizeScript(sid: string, lang?: string): void {
    const script: HTMLScriptElement = this.document.createElement('script');
    window['iAdvizeInterface'] = window['iAdvizeInterface'] || [];
    window['iAdvizeInterface'].config = lang
      ? { 'sid': sid, 'lang': lang }
      : { 'sid': sid };
    script.type = 'text/javascript';
    script.src = '//halc.iadvize.com/iadvize.js';
    script.async = true;
    this.document.body.appendChild(script);
  }
}
